export default function sortWorks(works) {
	if (!works) {
		return works;
	}

	// Sort works by:
	// 1. Serie number (if applicable)
	// 2. Name (alphabetically, with numeric sorting)
	return [...works].sort(
		(a, b) =>
			(a.serieNumber || 0) - (b.serieNumber || 0) || a.name.localeCompare(b.name, undefined, { numeric: true }),
	);
}
